export const pushToHubSpotQueue = (event: string, data?: unknown) =>
  (window._hsq = window._hsq || []).push([event, data]);
